import { Firehose } from '@aws-sdk/client-firehose';
import { CognitoIdentityCredentialProvider } from '@aws-sdk/credential-providers';
import _ from 'lodash';

import { getCredentials } from '.';
import { NODE_ENV, IS_FEDERAL, STACK } from '@scale/frontend-lib/constants';
import * as firehose from '@scale/shared/utils/firehose';

const isTest = NODE_ENV === 'TEST';
let client: Firehose | null = null;

function getClient(credentials: CognitoIdentityCredentialProvider) {
  if (IS_FEDERAL) {
    throw new Error('Not allowed in federal');
  }
  if (client) {
    return client;
  }
  const _client = new Firehose({
    credentials,
    region: 'us-west-2',
    apiVersion: '2015-08-04',
  });
  client = _client;
  return _client;
}

export async function putRecords(
  DeliveryStreamName: string,
  items: string[],
  options?: firehose.PutRecordOptions,
) {
  if (isTest || IS_FEDERAL || STACK !== 'production') {
    return; // Only make AWS call on commercial production
  }

  const client = getClient(await getCredentials());

  const output = await firehose.putRecords(DeliveryStreamName, items, client, options);
  const failed = output.failedRecords;
  if (failed.length > 0) {
    const errorCodes = _.uniq(failed.map(i => i.errorCode));
    const errorMessages = _.uniq(failed.map(i => i.errorMessage));
    throw new Error(`Failed to put ${failed.length} records: ${errorCodes}; ${errorMessages}`);
  }
  return output.successCount;
}
